import { all, fork } from 'redux-saga/effects';
import clusterRolesSaga from './clusterRoles/clusterRoles.saga';

function* dataAccessControlSaga() {
  yield all([fork(clusterRolesSaga)]);
}

export default dataAccessControlSaga;
